import React, { useState } from "react";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import RowButton from "../../../components/ui_comps/RowButton";
function SendMoneyModal() {
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [amount, setAmount] = useState("");
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    height: 50,
    marginBottom: 20,
    width: "100%",
  };

  const textStyle = {
    fontSize: 12,
    color: "#6C6B6B",
    margin: "5px 0px 5px 20px",
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <div>
        <p style={textStyle}>Beneficiary Name</p>

        <CustomInput
          value={beneficiaryName}
          onChange={(data) => setBeneficiaryName(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Beneficiary Name"
          validator="name"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>
      <div>
        <p style={textStyle}>Beneficiary Bank Account Number</p>

        <CustomInput
          value={accountNumber}
          onChange={(data) => setAccountNumber(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Bank account number"
          validator="accountNumber"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>
      <div>
        <p style={textStyle}>Account Number</p>

        <CustomInput
          value={accountNumber}
          onChange={(data) => setAccountNumber(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Bank account number"
          validator="accountNumber"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>
      <div>
        <p style={textStyle}>Beneficiary IFSC Code</p>

        <CustomInput
          value={ifscCode}
          onChange={(data) => setIfscCode(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Bank IFSC code"
          validator="ifscCode"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>
      <div>
        <p style={textStyle}>Amount</p>

        <CustomInput
          value={ifscCode}
          onChange={(data) => setAmount(data)}
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="Enter Amount"
          validator="ifscCode"
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
        />
      </div>

      <RowButton onClickBack={() => {}} onClickNext={() => {}} />
    </div>
  );
}

export default SendMoneyModal;
